import React from "react";
import { useTranslation } from 'react-i18next';

interface AppLogoProps {
  isLoading?: boolean;
  onClick?: () => void;
  href?: string;
  className?: string;
}

export const AppLogo: React.FC<AppLogoProps> = ({ 
  isLoading = false, 
  onClick, 
  href,
  className = "" 
}) => {
  console.log('[AppLogo] Rendering');
  const { t } = useTranslation();
  console.log('[AppLogo] useTranslation hook called successfully');
  const content = (
    <div 
      className={`flex items-center gap-[0.3rem] ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="relative">
        {/* Subtle, smaller glow positioned lower */}
        <div className="absolute top-1 left-0 right-0 bottom-0 bg-green-500/10 blur-md rounded-full" />
        <img 
          src="/brand-logo-nobg.png" 
          alt={t('accessibility.labels.gitfit_ai_logo')} 
          className="relative h-10 w-10 grayscale opacity-50"
          loading="eager" 
          fetchpriority="high" 
          decoding="async"
        />
      </div>
      <h1 className="text-lg font-[50] text-muted-foreground/30">
        gitfit.ai
      </h1>
    </div>
  );

  if (href) {
    return <a href={href}>{content}</a>;
  }

  return content;
};
